<script lang="ts" setup>
import { useMyAccountLocalStorage } from './composables/my-account'

const props = defineProps<{
  recaptchaKey?: string
  apiKey?: string
}>()

const { t } = useTranslation()
const userStore = useUserStore()
const verification = useVerification({ recaptchaKey: props.recaptchaKey, apiKey: props.apiKey })
const { emailSentTo, setEmailSentTo } = useMyAccountLocalStorage()
const errorMessage = ref()
const showChangeEmailAlert = ref(false)

const submitRequest = async () => {
  const response = await verification.resendVerificationEmail()

  if (!response?.success) {
    if (response?.data?.messageCode === 'user-has-active-email-change-request')
      set(showChangeEmailAlert, true)
    else
      set(errorMessage, response?.data?.message)
  }
  else {
    setEmailSentTo({
      requestPage: 'resend-email',
      email: userStore.user?.email ?? '',
    })
    customNavigateTo({
      name: 'kundenkonto-userId-email-andern-erfolg',
      params: { userId: userStore.userId! },
    })
  }
}
</script>

<template>
  <div
    class="mx-auto max-w-510px"
  >
    <IaAlert
      v-if="errorMessage"
      type="error"
      class="mb-6 !w-full"
    >
      {{ errorMessage }}
    </IaAlert>

    <IaHeading
      :level="2"

      mb-4
      font-700
    >
      {{ t('unverifiedUser.resendPage.title') }}
    </IaHeading>

    <IaParagraph
      color="!grey-600"
      class="mb-8 sm:mb-12"
    >
      {{ t('unverifiedUser.resendPage.content') }}
    </IaParagraph>

    <div
      class="divider"
    >
      <div
        flex="~ col gap-6 sm:gap-4"
        class="pb-6"
      >
        <div
          flex="~ col gap-4 sm:row"
          class="sm:justify-between"
        >
          <div>
            <IaParagraph
              size="sm"
              color="!grey-600"
            >
              {{ t('unverifiedUser.resendPage.yourEmail') }}
            </IaParagraph>
            <IaParagraph font-700>
              {{ userStore.user?.email }}
            </IaParagraph>
          </div>
          <IaButton
            :disabled="showChangeEmailAlert"
            @click="submitRequest"
          >
            {{ t('unverifiedUser.resendPage.sendRequest') }}
          </IaButton>
        </div>

        <IaAlert
          v-if="showChangeEmailAlert"
          type="warning"
          class="!w-full"
        >
          <span v-html="t('unverifiedUser.resendPage.emailChanged', { email: emailSentTo?.email })"></span>
        </IaAlert>
      </div>

      <div
        flex="~ col gap-4 sm:row"
        class="pt-6 sm:justify-between"
      >
        <div>
          <IaParagraph
            color="!grey-600"
            class="max-w-304px"
            size="sm"
          >
            {{ t('unverifiedUser.resendPage.incorrectEmail') }}
          </IaParagraph>
        </div>
        <IaButton
          variant="outline"
          @click="customNavigateTo({
            name: 'kundenkonto-userId-email-andern',
            params: { userId: userStore.userId! },
          })"
        >
          {{ t('unverifiedUser.resendPage.changeEmail') }}
        </IaButton>
      </div>
    </div>
  </div>
</template>
